<template>
  <div class="wrapper ">
    <Sidebar />
    <div class="main-panel" id="main-panel">
      <Header />
      <div class="panel-header panel-header-sm">
        <canvas id="bigDashboardChart"></canvas>
      </div>
      <div class="content">
        <Loading v-if="loading === true" />
        <transition name="modal" v-if="selectedCurator != null">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <Alert
                  v-if="errorMessage.length > 0"
                  :message="errorMessage"
                  :error="true"
                />
                <Alert
                  v-if="successMessage.length > 0"
                  :message="successMessage"
                  :error="false"
                />
                <div class="modal-header">
                  <slot name="header">
                    <h3 class="mb-0">Edit User</h3>
                  </slot>
                </div>
                <div class="modal-body">
                  <slot name="body">
                    <div
                      v-if="selectedCurator.thumbnail != null"
                      class="row mb-5 mt-0"
                    >
                      <div class="col-6">
                        <img
                          class="profile-pic"
                          :src="selectedCurator.thumbnail"
                        />
                      </div>
                      <div class="col">
                        <button
                          v-if="
                            editing == true &&
                              successMessage == '' &&
                              errorMessage == ''
                          "
                          class="btn btn-primary"
                          @click="updateUser()"
                        >
                          Update
                        </button>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col">
                        <label>Name</label>
                        <input
                          v-model="selectedCurator.name"
                          type="text"
                          placeholder="* Name"
                          class="form-control"
                        />
                      </div>
                      <div class="col">
                        <label>Display Name</label>
                        <input
                          v-model="selectedCurator.displayName"
                          type="text"
                          placeholder="* Display Name"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col">
                        <label>Job Title</label>
                        <input
                          v-model="selectedCurator.jobTitle"
                          type="text"
                          placeholder="* Job Title"
                          class="form-control"
                        />
                      </div>
                      <div class="col">
                        <label>Phone Number</label>
                        <input
                          v-model="selectedCurator.phoneNumber"
                          type="text"
                          placeholder="* Phone Number"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <label>Institute</label>
                        <select
                          v-model="selectedCurator.museumID"
                          style="padding: 10px;"
                          class="form-control"
                        >
                          <option disabled value="">Select Institute</option>
                          <option
                            v-for="museum in allMuseums"
                            :key="museum.id"
                            :value="museum.id"
                            >{{ museum.name }}</option
                          >
                        </select>
                      </div>
                    </div>

                    <div
                      v-if="selectedCurator.isPlatinum === true"
                      class="row mt-4"
                    >
                      <div class="col">
                        <label>Artwork Limit</label>
                        <input
                          v-model="selectedCurator.artworkLimit"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="col">
                        <label>Push Notification Limit</label>
                        <input
                          v-model="selectedCurator.pushNotificationLimit"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <div v-if="selectedCurator.isPlatinum === true" class="row">
                      <div class="col">
                        <label>Push Notification Recipient Limit</label>
                        <input
                          v-model="
                            selectedCurator.pushNotificationRecipientLimit
                          "
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="col">
                        <label>Catalog User Limit</label>
                        <input
                          v-model="selectedCurator.catalogUserLimit"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </slot>
                </div>
                <div>
                  <slot name="footer">
                    <button
                      class="btn btn-danger btn-orange"
                      style="font-size: 14px;"
                      @click="deleteUser(selectedCurator.id)"
                    >
                      <i class="fa fa-trash mr-2"></i>Delete
                    </button>
                    <button
                      class="btn btn-primary modal-default-button"
                      @click="
                        selectedCurator = null;
                        errorMessage = '';
                        successMessage = '';
                      "
                    >
                      Close
                    </button>
                    <button
                      class="btn btn-primary modal-default-button"
                      @click="updateCurator(selectedCurator)"
                    >
                      Update
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="row">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Curator Information:</h4>
              <h5 class="card-category">* Mandatory Fields</h5>
            </div>
            <div class="card-body">
              <div class="form-group">
                <div class="row mb-3">
                  <div class="col-4">
                    <label>* First Name</label>
                    <input
                      v-model="curator.firstName"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-4">
                    <label>* Last Name</label>
                    <input
                      v-model="curator.lastName"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-4">
                    <label>* Display Name</label>
                    <input
                      v-model="curator.displayName"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-4">
                    <label>* Job Title</label>
                    <input
                      v-model="curator.jobTitle"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-4">
                    <label>* Email Address</label>
                    <input
                      v-model="curator.email"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-4">
                    <label>* Phone Number</label>
                    <input
                      v-model="curator.phoneNumber"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 ml-3">
                    <label class="form-check-label"
                      ><input type="checkbox" v-model="curator.isPlatinum" />
                      Platinum Curator</label
                    >
                  </div>
                </div>
                <div v-if="curator.isPlatinum === true">
                  <div class="row mb-3">
                    <div class="col-6">
                      <label>* Artwork Limit</label>
                      <input
                        v-model="curator.artworkLimit"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="col-6">
                      <label>* Push Notification Limit</label>
                      <input
                        v-model="curator.pushNotificationLimit"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-6">
                      <label>* Push Notification Recipient Limit</label>
                      <input
                        v-model="curator.pushNotificationRecipientLimit"
                        type="text"
                        class="form-control"
                      />
                    </div>
                    <div class="col-6">
                      <label>* Catalog User Limit</label>
                      <input
                        v-model="curator.catalogUserLimit"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col">
                    <select
                      class="form-control custom-dropdown"
                      v-model="selectedMuseum"
                    >
                      <option disabled selected value=""
                        >Pick an Institute</option
                      >
                      <option
                        v-for="museum in allMuseums"
                        :key="museum.id"
                        :value="museum.id"
                        >{{ museum.name }}</option
                      >
                    </select>
                  </div>
                </div>

                <button class="btn btn-primary mt-5" @click="createCurator()">
                  Invite
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="content w-100" style="margin-top: 20px;">
          <div class="tabs">
            <a
              style="font-weight: 500;"
              @click="activeTab = 1"
              :class="[activeTab === 1 ? 'active' : '']"
              >Active Curators</a
            >
            <a
              style="font-weight: 500;"
              @click="activeTab = 2"
              :class="[activeTab === 2 ? 'active' : '']"
              >Suspended Curators</a
            >
          </div>
          <div id="row">
            <div v-if="activeTab === 1" class="card">
              <div class="card-body">
                <v-client-table
                  :data="tableData"
                  :columns="columns"
                  :options="options"
                >
                  <div
                    slot="thumbnail"
                    slot-scope="{ row }"
                    style="text-align: center;"
                  >
                    <img style="max-width: 3em;" :src="row.thumbnail" />
                  </div>

                  <div slot="actions" slot-scope="{ row }">
                    <button
                      @click="suspendMember(row)"
                      class="transparent-button"
                    >
                      <i class="delete-button fa fa-trash"></i> Suspend
                    </button>
                    <button
                      @click="editCurator(row)"
                      class="transparent-button ml-3"
                    >
                      <i class="edit-button fa fa-edit"></i> Edit
                    </button>
                    <button
                      v-if="isSuperAdmin === true"
                      @click="deleteUser(row.id)"
                      class="transparent-button"
                    >
                      <i class="delete-button fa fa-trash"></i> Delete
                    </button>
                    <button
                      @click="resetPassword(row)"
                      class="transparent-button"
                    >
                      <i class="fa fa-undo"></i> Reset Password
                    </button>
                  </div>
                </v-client-table>
              </div>
            </div>
            <div v-else class="card">
              <div class="card-body">
                <v-client-table
                  :data="suspendedCurators"
                  :columns="columns"
                  :options="options"
                >
                  <div
                    slot="thumbnail"
                    slot-scope="{ row }"
                    style="text-align: center;"
                  >
                    <img style="max-width: 3em;" :src="row.thumbnail" />
                  </div>
                  <div slot="actions" slot-scope="{ row }">
                    <button
                      @click="unsuspendMember(row)"
                      class="transparent-button"
                    >
                      <i class="green-button fa fa-reply"></i> Unsuspend
                    </button>
                  </div>
                </v-client-table>
              </div>
            </div>
          </div>
          
        </div>
        <Alert
          v-if="errorMessage.length > 0"
          :message="errorMessage"
          :error="true"
        />
        <Alert
          v-if="successMessage.length > 0"
          :message="successMessage"
          :error="false"
        />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Admins from "../controllers/admin.controller";
import Users from "../controllers/user.controller";
import isSuperAdmin from "../services/jwt/isSuperAdmin";
import Museums from "../controllers/museum.controller";
import Plans from "../controllers/plans.controller";
import Members from "../controllers/members.controller";

export default {
  name: "Users",
  data: function() {
    return {
        activeTab: 1,
      curator: {
        isPlatinum: false,
      },
      allMuseums: [],
      superAdmin: {},
      loading: false,
      editing: false,
      errorMessage: "",
      successMessage: "",
      curators: [],
      selectedCurator: null,
      isSuperAdmin: isSuperAdmin(localStorage.getItem("superAdmin")),
      columns: [
        "name",
        "thumbnail",
        "displayName",
        "email",
        "subscription",
        "jobTitle",
        "museum",
        "phoneNumber",
        "actions",
      ],
      tableData: [],
      selectedMuseum: "",
      suspendedCurators: [],
      options: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        filterable: true,
        headings: {
          thumbnail: "Profile Picture",
          name: "Name",
          email: "Email",
          displayName: "Display Name",
          subscription: "Subscription",
          jobTitle: "Job Title",
          museum: "Institute",
          phoneNumber: "Phone Number",
          actions: "Actions",
        },
        sortIcon: {
          base: "fa",
          is: "fa-sort",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
        },
      },
    };
  },

  beforeMount: async function() {
    this.loading = true;
    await this.getCurators();

    this.allMuseums = await Museums.getAll();
    this.loading = false;
  },

  methods: {
    async unsuspendMember(memberInfo) {
      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;

      let suspended = await Members.unsuspend(memberInfo.firebaseID);

      if (suspended === true) {
        this.successMessage = "User Unsuspended Successfully";
        await this.getCurators();
        this.loading = false;
      } else {
        this.errorMessage = "Something went wrong while suspending the user";
        this.loading = false;
      }
      this.loading = false;
    },
    async suspendMember(memberInfo) {
      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;

      let suspended = await Members.suspend(memberInfo.firebaseID);

      if (suspended === true) {
        this.successMessage = "User Suspended Successfully";
        await this.getCurators();
        this.loading = false;
      } else {
        this.errorMessage = "Something went wrong while suspending the user";
        this.loading = false;
      }
      this.loading = false;
    },
    async getCurators() {
      this.curators = await Admins.getCurators();
      this.suspendedCurators = [];
      this.tableData = [];
      if (this.curators.length > 0) {

        
        this.curators.forEach((curator) => {
          let curatorMuseums = curator.curator_museums;
          if(curator.suspended != 1){
            this.tableData.push({
            id: curator.id,
            firebaseID: curator.firebase_id,
            thumbnail: curator.profile_pic,
            name: curator.name,
            email: curator.email,
            displayName: curator.display_name,
            subscription: !curator.subscription
              ? "N/A"
              : curator.subscription.subscription_status,
            jobTitle: curator.job_title,
            phoneNumber: curator.phone_number,
            subscriptionInfo: curator.subscription,
            isPlatinum:
              curator.subscription &&
              curator.subscription.subscription_status === "Platinum"
                ? true
                : false,
            museum: curatorMuseums.length > 0 ? curatorMuseums[0].name : "N/A",
            museumID: curatorMuseums.length > 0 ? curatorMuseums[0].id : null,
          });
          }else{
            this.suspendedCurators.push({
            id: curator.id,
            firebaseID: curator.firebase_id,
            thumbnail: curator.profile_pic,
            name: curator.name,
            email: curator.email,
            displayName: curator.display_name,
            subscription: !curator.subscription
              ? "N/A"
              : curator.subscription.subscription_status,
            jobTitle: curator.job_title,
            phoneNumber: curator.phone_number,
            subscriptionInfo: curator.subscription,
            isPlatinum:
              curator.subscription &&
              curator.subscription.subscription_status === "Platinum"
                ? true
                : false,
            museum: curatorMuseums.length > 0 ? curatorMuseums[0].name : "N/A",
            museumID: curatorMuseums.length > 0 ? curatorMuseums[0].id : null,
          });
          }
        });

        // Order the plans Platinum - Gold - Silver - Bronze
        this.tableData.sort((a, b) => {
          if (a.subscription.includes("Platinum")) {
            a = 4;
          } else if (a.subscription.includes("Gold")) {
            a = 3;
          } else if (a.subscription.includes("Silver")) {
            a = 2;
          } else if (a.subscription.includes("Bronze")) {
            a = 1;
          } else {
            a = 0;
          }

          if (b.subscription.includes("Platinum")) {
            b = 4;
          } else if (b.subscription.includes("Gold")) {
            b = 3;
          } else if (b.subscription.includes("Silver")) {
            b = 2;
          } else if (b.subscription.includes("Bronze")) {
            b = 1;
          } else {
            b = 0;
          }

          if (a > b) {
            return -1;
          } else if (b > a) {
            return 1;
          }

          return 0;
        });
      }
    },

    async createCurator() {
      this.errorMessage = "";
      this.successMessage = "";

      if (
        !this.curator.firstName ||
        !this.curator.lastName ||
        !this.curator.jobTitle ||
        !this.curator.email ||
        !this.curator.phoneNumber ||
        !this.curator.displayName ||
        this.selectedMuseum == ""
      ) {
        this.errorMessage = "Please make sure all mandatory fields are filled";
        return;
      }

      if (
        this.curator.isPlatinum == true &&
        (!this.curator.artworkLimit ||
          !this.curator.pushNotificationLimit ||
          !this.curator.pushNotificationRecipientLimit ||
          !this.curator.catalogUserLimit)
      ) {
        this.errorMessage = "Please make sure all mandatory fields are filled";
        return;
      }

      if (
        this.curator.isPlatinum == true &&
        (isNaN(this.curator.artworkLimit) ||
          isNaN(this.curator.pushNotificationLimit) ||
          isNaN(this.curator.pushNotificationRecipientLimit) ||
          isNaN(this.curator.catalogUserLimit))
      ) {
        this.errorMessage = "Please make sure all mandatory fields are filled";
        return;
      }

      this.loading = true;

      let invite = await Admins.sendCuratorInvite(
        this.curator,
        this.selectedMuseum
      );

      if (invite.error) {
        this.errorMessage = invite.error;
      } else if (invite == false) {
        this.errorMessage = "Something went wrong creating the curator";
      } else {
        this.curator = {};
        this.tableData = [];
        await this.getCurators();
        this.successMessage = "Curator Invite Sent";
      }

      this.loading = false;
    },

    async editCurator(curator) {
      this.successMessage = "";
      this.errorMessage = "";
      this.loading = true;

      this.selectedCurator = curator;

      if (this.selectedCurator.isPlatinum === true) {
        let plan = await Plans.getById(curator.subscriptionInfo.plan_id);
        this.selectedCurator.planID = curator.subscriptionInfo.plan_id;
        this.selectedCurator.artworkLimit = plan.artwork_limit;
        this.selectedCurator.catalogUserLimit = plan.catalog_user_limit;
        this.selectedCurator.pushNotificationLimit =
          plan.push_notification_limit;
        this.selectedCurator.pushNotificationRecipientLimit =
          plan.push_notification_recipient_limit;
      }

      this.loading = false;
    },

    async updateCurator() {
      this.errorMessage = "";
      this.successMessage = "";
      this.loading = true;

      this.selectedCurator.museums = [];
      this.selectedCurator.museums.push(this.selectedCurator.museumID);

      if (
        !this.selectedCurator.firebaseID ||
        !this.selectedCurator.name ||
        !this.selectedCurator.displayName ||
        !this.selectedCurator.jobTitle ||
        !this.selectedCurator.phoneNumber ||
        this.selectedCurator.museums.length < 1
      ) {
        this.errorMessage = "Please make sure all mandatory fields are filled";
        return;
      }

      let updated = await Users.update(
        this.selectedCurator.firebaseID,
        this.selectedCurator.name,
        this.selectedCurator.displayName,
        this.selectedCurator.jobTitle,
        this.selectedCurator.phoneNumber
      );
      if (updated == false) {
        this.errorMessage = "Something went wrong while updating the curator";
      } else if (updated.error) {
        this.errorMessage = updated.error;
      } else {
        if (this.selectedCurator.isPlatinum === true) {
          let updatedLimits = await Plans.updatePlatinumLimits(
            this.selectedCurator.id,
            this.selectedCurator.planID,
            this.selectedCurator.artworkLimit,
            this.selectedCurator.pushNotificationLimit,
            this.selectedCurator.pushNotificationRecipientLimit,
            this.selectedCurator.catalogUserLimit
          );
          if (updatedLimits.error) {
            this.errorMessage = updatedLimits.error;
            this.loading = false;
            return;
          } else if (updatedLimits === false) {
            this.errorMessage =
              "Something went wrong while updating the curator.";
            this.loading = false;
            return;
          }
        }

        let updatedMuseums = await Users.updateCuratorMuseum(
          this.selectedCurator.firebaseID,
          this.selectedCurator.museums
        );
        if (updatedMuseums.error) {
          this.errorMessage = updatedMuseums.error;
          this.loading = false;
          return;
        } else if (updatedMuseums === false) {
          this.errorMessage = "Something went wrong while updating the curator";
          this.loading = false;
          return;
        }

        this.successMessage = "Curator updated successfully";
        this.editing = false;
        this.selectedCurator = null;
        this.tableData = [];

        // Refresh the curator list
        await this.getCurators();

        this.loading = false;
      }
    },

    async resetPassword(user) {
      if (!user.email) {
        this.errorMessage = "This user doesn't have an email on record.";
        return;
      }

      this.loading = true;

      this.successMessage = "";
      this.errorMessage = "";

      let emailSent = await Users.resetPassword(user.email);

      if (emailSent === true) {
        this.successMessage =
          "Reset password email successfully sent to member";
      } else {
        this.errorMessage =
          "Something went wrong while sending reset password email";
      }

      this.loading = false;
    },

    async deleteUser(userID) {
      if (!userID) {
        this.errorMessage = "UserID is missing";
        return;
      }

      this.loading = true;

      let updated = await Users.delete(userID);

      if (updated == false) {
        this.errorMessage = "Something went wrong while updating the curator";
      } else if (updated.error) {
        this.errorMessage = updated.error;
      } else {
        this.successMessage = "Curator deleted successfully";
        this.editing = false;
        this.selectedCurator = null;
        this.tableData = [];

        // Refresh the curator list
        this.getCurators();

        this.loading = false;
      }
    },
  },
};
</script>
